import React, { useState, useEffect } from 'react'
import GiftList from '../views/GiftList'
import { getPurchases } from '../api'
import Loading from '../views/common/Loading'
import Header from '../views/common/Header'
import { Container } from '../styles/elements'

const usePurchases = () => {
  const [purchases, setPurchases] = useState([])
  const [loading, setLoading] = useState()

  useEffect(() => {
    const getLoyaltyPurchases = async () => {
      setLoading(true)
      const loyaltyPurchases = await getPurchases()
      setLoading(false)
      setPurchases(loyaltyPurchases)
    }
    getLoyaltyPurchases()
  }, [])

  return [purchases, loading]
}

export default ({ loyalty: { status: { point } } }) => {
  const [purchases, loading] = usePurchases()

  return (
    <>
      <Header score={point} />
      <Container>
        {purchases && purchases.purchaseHistory &&
          <GiftList
            items={purchases.purchaseHistory.map((purchase => ({
              ...purchase.item,
              expirationDate: purchase.expirationDate,
              purchaseDate: purchase.purchaseDate,
            })))}
            isPaid
          />
        }
        {loading &&
          <Loading />
        }
      </Container>
    </>
  )
}
